import React, { useLayoutEffect } from 'react';
import {
  searchParamKeys,
  defaultCalendarMode,
  calendarModes,
  searchParamSelectors,
} from '../../../../shared/configs/searchParams';
import {
  useSearchParamsMethods,
  useSearchParamsSelector,
} from '../../../../shared/packages/searchParamsManager';
import { useCalendarManager } from '../../../../services/queries/calendar';

const { calendarMode: modeKey, calendarPage: pageKey } = searchParamKeys;

const CalendarModePageGuard = ({ children }) => {
  const calendarManager = useCalendarManager();

  const mode = useSearchParamsSelector(searchParamSelectors[modeKey]);
  const page = useSearchParamsSelector(searchParamSelectors[pageKey]);

  const { setParams } = useSearchParamsMethods();

  const modeValid = isModeValid(mode);

  const count = calendarManager.getPageCount(mode);

  const pageValid = isPageValid(page, count);

  useLayoutEffect(() => {
    if (!modeValid) {
      const params = { [modeKey]: defaultCalendarMode };

      if (!pageValid) {
        params[pageKey] = 1;
      }

      setParams(params);
      return;
    }

    if (!pageValid) {
      setParams({ [pageKey]: 1 });
    }
  }, [modeValid, pageValid, page, setParams]);

  return modeValid && pageValid ? <>{children}</> : null;
};

export default CalendarModePageGuard;

function isModeValid(mode) {
  return calendarModes.includes(mode);
}

function isPageValid(page, count) {
  const numberPage = Number(page);

  return !isNaN(numberPage) && numberPage >= 1 && numberPage <= count;
}
